import dayjs, { type ConfigType } from "dayjs";
import type { LayoutAxis } from "plotly.js";
import { ONE_DAY, ONE_MINUTE } from "./time";

export const DATE_FORMAT = "DD MMM YYYY";
export const TIME_FORMAT = "HH:mm";
export const DATE_TIME_FORMAT = `${DATE_FORMAT}, ${TIME_FORMAT}`;

export const formatDate = (date: ConfigType) => dayjs(date).format(DATE_FORMAT);

export const formatTime = (date: ConfigType) => dayjs(date).format(TIME_FORMAT);

export const formatDateTime = (date: ConfigType) =>
  dayjs(date).format(DATE_TIME_FORMAT);

export const plotlyDateAxis: Partial<LayoutAxis> = {
  type: "date",
  hoverformat: "%d %b %Y, %H:%M",
  tickformatstops: [
    { dtickrange: [null, ONE_MINUTE], value: "%H:%M:%S<br>%d %b %Y" },
    { dtickrange: [ONE_MINUTE, ONE_DAY], value: "%H:%M<br>%d %b %Y" },
    { dtickrange: [ONE_DAY, null], value: "%d %b %Y" },
  ],
};
